export const statusCheck=(status)=>{
    let severity=''
    if(status === 'LIVRÉ') severity = '#05B171'
    else if (status === 'ÉXPEDIÉ') severity = '#2c00db'
    else if (status === 'ANNULÉE') severity = '#C93A3A'
    else if (status === 'EN COURS') severity = '#FAAE42'
    else severity = '#293134'
    return severity
}